import { render, staticRenderFns } from "./PageAddress.vue?vue&type=template&id=380b598f"
import script from "./PageAddress.vue?vue&type=script&lang=js"
export * from "./PageAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports